var map = {
	"./01_get_currentTrack.json": "lgiQ",
	"./02_post_close_currentTrack.json": "TSOU",
	"./03_post_tpsl_currentTrack.json": "UWbd",
	"./05_swap_trader_detail.json": "ds0K",
	"./06_swap_trader_profit_summary.json": "4DDS",
	"./07_swap_trader_profit_detail.json": "eNxZ",
	"./08_swap_trader_set_commission.json": "7lDL",
	"./09_swap_trader_trading_pair.json": "fvxU"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "DifX";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/copyTrade/api/pFuturesTrader \.json$
// module id = DifX
// module chunks = 3